import React, { useState } from "react";
import { ListPageHeader } from "../../common/DataList";
import { TabPanel, Tabs } from "../../common/Fiche";
import RDOInviteImport from "./RDOInviteImport";
import RDOInviteList from "./RDOInviteList";

// Onglets du kit, comme les sanctions France Travail ; l'onglet et le numéro de
// lot se lisent toujours dans l'URL (?tab=list&numeroLot=…).
const ONGLETS = [
  { id: "import", label: "Importer des invitations", icon: "fa-upload" },
  { id: "list", label: "Liste des invitations", icon: "fa-list" },
];

const RDOInvite = () => {
  // Récupérer les paramètres GET de l'URL
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get("tab");
  const numeroLotParam = urlParams.get("numeroLot");

  const [activeTab, setActiveTab] = useState(tabParam || "import");

  return (
    <div className="container-fluid px-5 my-5 list-page">
      <ListPageHeader title="Invitation RDO" />
      <Tabs
        tabs={ONGLETS}
        activeId={activeTab}
        onChange={setActiveTab}
        idPrefix="rdo-invite"
        ariaLabel="Invitation RDO"
      />
      <TabPanel id="import" activeId={activeTab} idPrefix="rdo-invite">
        <RDOInviteImport />
      </TabPanel>
      <TabPanel id="list" activeId={activeTab} idPrefix="rdo-invite">
        <RDOInviteList numeroLotInitial={numeroLotParam} />
      </TabPanel>
    </div>
  );
};
export default RDOInvite;
